import { Timestamp } from '@firebase/firestore';

// ── Collection 경로 상수 ──
export const COUPANG_ORDERS_COLLECTION = process.env.REACT_APP_COUPANG_ORDERS_COLLECTION as string;
export const COUPANG_DAILY_SUMMARY_COLLECTION = process.env.REACT_APP_COUPANG_DAILY_SUMMARY_COLLECTION as string;
export const COUPANG_CANCELS_COLLECTION = process.env.REACT_APP_COUPANG_CANCELS_COLLECTION as string;
export const COUPANG_CANCELS_DAILY_SUMMARY_COLLECTION = process.env.REACT_APP_COUPANG_CANCELS_DAILY_SUMMARY_COLLECTION as string;
export const LINKPRICE_REWARDS_COLLECTION = process.env.REACT_APP_LINKPRICE_REWARDS_COLLECTION as string;
export const LINKPRICE_CANCELS_COLLECTION = process.env.REACT_APP_LINKPRICE_CANCELS_COLLECTION as string;
export const LINKPRICE_CANCELS_DAILY_SUMMARY_COLLECTION = process.env.REACT_APP_LINKPRICE_CANCELS_DAILY_SUMMARY_COLLECTION as string;
export const LINKPRICE_TRANSACTIONS_COLLECTION = process.env.REACT_APP_LINKPRICE_TRANSACTIONS_COLLECTION as string;

// ── Coupang 주문 ──
export interface CoupangOrder {
  id?: string;
  orderId: string;
  orderDate: Timestamp | string;
  productName?: string;
  price: number;
  commission: number;
  quantity?: number;
  status?: string;
  [key: string]: unknown;
}

// ── Coupang 일별 요약 ──
export interface CoupangDailySummary {
  id?: string;
  date: string; // YYYY-MM-DD
  totalOrders: number;
  totalRevenue: number;
  totalCommission: number;
  [key: string]: unknown;
}

// ── Coupang 취소 ──
export interface CoupangCancel {
  id?: string;
  orderId?: string;
  cancelDate: Timestamp | string;
  amount: number;
  reason?: string;
  [key: string]: unknown;
}

// ── Coupang 취소 일별 요약 ──
export interface CoupangCancelsDailySummary {
  id?: string;
  date: string;
  totalCancels: number;
  totalAmount: number;
  [key: string]: unknown;
}

// ── Linkprice 리워드 ──
export interface LinkpriceReward {
  id?: string;
  date: Timestamp | string;
  merchantName?: string;
  amount: number;
  commission: number;
  status?: string;
  [key: string]: unknown;
}

// ── Linkprice 취소 ──
export interface LinkpriceCancel {
  id?: string;
  cancelDate: Timestamp | string;
  amount: number;
  reason?: string;
  [key: string]: unknown;
}

// ── Linkprice 취소 일별 요약 ──
export interface LinkpriceCancelsDailySummary {
  id?: string;
  date: string;
  totalCancels: number;
  totalAmount: number;
  [key: string]: unknown;
}

// ── 대시보드 통합 통계 ──
export interface DashboardStats {
  totalCoupangRevenue: number;
  totalCoupangOrders: number;
  totalCoupangCommission: number;
  totalCoupangCancels: number;
  totalCoupangCancelAmount: number;
  totalLinkpriceRevenue: number;
  totalLinkpriceRewards: number;
  totalLinkpriceCommission: number;
  totalLinkpriceCancels: number;
  totalLinkpriceCancelAmount: number;
  totalUsers: number;
  totalEnterprises: number;
}

// ── 일별 차트 데이터 ──
export interface DailyChartData {
  date: string;
  coupangRevenue: number;
  coupangOrders: number;
  coupangCommission: number;
  linkpriceRevenue: number;
  linkpriceRewards: number;
  linkpriceCommission: number;
  coupangCancels: number;
  coupangCancelAmount: number;
  linkpriceCancels: number;
  linkpriceCancelAmount: number;
}
